import { createContext, useContext, type ReactNode } from "react";
import type { TabId } from "@/routes/routeObjects";

type TabActivity = {
  tabId: TabId;
  isActive: boolean;
};

const TabActivityContext = createContext<TabActivity | null>(null);

export function TabActivityProvider({
  tabId,
  isActive,
  children,
}: {
  tabId: TabId;
  isActive: boolean;
  children: ReactNode;
}) {
  return <TabActivityContext.Provider value={{ tabId, isActive }}>{children}</TabActivityContext.Provider>;
}

export function useTabActivity() {
  const context = useContext(TabActivityContext);
  if (!context) {
    throw new Error("useTabActivity must be used within TabActivityProvider");
  }
  return context;
}

export function useOptionalTabActivity() {
  return useContext(TabActivityContext);
}

export function useIsTabActive(defaultValue = true) {
  return useContext(TabActivityContext)?.isActive ?? defaultValue;
}
